import Vue from "vue";
import Vuex from "vuex";

import userModule from "./modules/user/index";
import ncsModule from "./modules/ncs/index";
import csModule from "./modules/cs/index";
import infoModule from "./modules/info/index";
import logModule from "./modules/log/index";
import gaModule from "./modules/analytics/index";
import pgModule from './modules/pg/index';
import ssrModule from './modules/ssr/index';
import controlModule from './modules/controls/index';
import workerModule from './modules/worker/index';
import transitionModule from './modules/transition/index';
import couponModule from './modules/coupon/index';


Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
import createMutationsSharer from "vuex-shared-mutations";

export default new Vuex.Store({
    modules: {
        user: userModule,
        ncs: ncsModule,
        cs: csModule,
        info: infoModule,
        log: logModule,
        ga: gaModule,
        pg: pgModule,
        ssr: ssrModule,
        control: controlModule,
        worker: workerModule,
        transition: transitionModule,
        coupon: couponModule,
    },
    plugins: [
        createPersistedState({
            storage: window.localStorage
        }),
        createMutationsSharer({
            predicate: [
                'user/CLEAR_STATES'
            ]
        })
    ]
});
